export const COORDINATES = "COORDINATES";
export const coordinatesAction = (data) => {
    return {
        type: COORDINATES,
        payload: data
    }
}